import axios from 'axios';
import { EquipsServiceAddress } from '../model/constants'
import {HandlerWrapper, GetTokenHeader} from './commonWorker'

const ServiceController = '/service';

export async function GetPassword(token, serialNumber, startDate, endDate) {
    return await HandlerWrapper('GetPassword', async () => {
        const response = await axios.get(EquipsServiceAddress + ServiceController +
            '/GetPassword?serialNumber=' + serialNumber +
            '&startDate=' + startDate +
            '&endDate=' + endDate,
            GetTokenHeader(token));
        return response.data;
    });
};